import React, { useEffect, useState } from "react";
import Modal from "@/components/chat/Modal";
import api from "@/lib/api";

// Very small markdown-ish renderer for headings/bold/paragraphs
function render(text) {
  return (text || "").split("\n").map((line, i) => {
    if (line.startsWith("## ")) return <h3 key={i} className="font-medium text-[var(--rc-gold)] mt-4 mb-1">{line.slice(3)}</h3>;
    if (line.startsWith("# ")) return <h2 key={i} className="font-heading text-2xl mb-2">{line.slice(2)}</h2>;
    if (!line.trim()) return <div key={i} className="h-2" />;
    return <p key={i} className="text-sm text-[var(--rc-text)] leading-relaxed">{line}</p>;
  });
}

export default function TermsDialog({ onClose }) {
  const [terms, setTerms] = useState("Loading…");
  useEffect(() => { api.get("/terms").then(({ data }) => setTerms(data.terms)).catch(() => setTerms("Could not load terms.")); }, []);
  return (
    <Modal title="Terms & Conditions" onClose={onClose}>
      <div data-testid="terms-dialog" className="max-h-[70vh] overflow-y-auto no-scrollbar">{render(terms)}</div>
    </Modal>
  );
}
